import { getDiff, useEffectAfterMount, useRelodeFormik } from "@relode/core";
import { IClientProfile } from "../../../shared/types/profile/IClientProfile";
import { SettingsActions } from "./settingsActions";
import { SettingsState } from "./settingsState";

export const useSettingsHandler = (
    state: SettingsState,
    actions: SettingsActions
) => {
    const { formik__infra } = useRelodeFormik<IClientProfile>();

    useEffectAfterMount(() => {
        const diffs = getDiff(
            formik__infra.initialValues,
            formik__infra.values
        );

        if (!diffs) return;

        const changes = {
            email: !!diffs["contact"]?.email,
            phoneNumber: !!diffs["contact"]?.phoneNumber,
            firstName: !!diffs["contact"]?.firstName,
            lastName: !!diffs["contact"]?.lastName,
            isAgentActive: !!diffs["isAgentActive"],
        };

        actions.setClientProfileChanged(changes);
    }, [formik__infra.values]);
};
